import React from 'react';
import { Link } from 'react-router-dom';
import Notification20 from '@carbon/icons-react/lib/notification/20';
import AppSwitcher20 from '@carbon/icons-react/lib/app-switcher/20';

import {
  Header,
  HeaderName,
  HeaderNavigation,
  HeaderMenu,
  HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderPanel,
  SkipToContent,
  Switcher,
  SwitcherDivider,
  SwitcherItem,
} from 'carbon-components-react/lib/components/UIShell';

const EditorHeader = () => (
  <Header aria-label="Context Editor">
    <SkipToContent />
    <HeaderName element={Link} to="/" prefix="Red Panda">
      Context Editor
    </HeaderName>
	<HeaderGlobalBar>
	{/*
      <HeaderGlobalAction
		aria-label="App Switcher"
		isActive
		onClick={() => {}}
	  >
        <AppSwitcher20/>
      </HeaderGlobalAction>
	  */}
    </HeaderGlobalBar>
	{/*
	<HeaderPanel expanded>
	  <Switcher>
		<SwitcherItem>
		Particle Editor
		</SwitcherItem>
		<SwitcherDivider/>
		<SwitcherItem>
		<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link>
		</SwitcherItem>
		<SwitcherItem> 
		<Link href="http://www.redpandalab.com/downloads/">Downloads</Link>
		</SwitcherItem>
		<SwitcherItem>
		<Link href="http://www.redpandalab.com/contact/">Contact Us</Link>
		</SwitcherItem>
	  </Switcher>
	</HeaderPanel>
	  */}
  </Header>
);

export default EditorHeader;
